// DEPRECATED NO NEED TO USE THIS ANY MORE
// withNavBars HOC is used to show the navbars(Top and Side Navbar) in any screens,
import React from "react";

const withNavBars = <P extends object>(Component: React.ComponentType<P>) => (props: any) => {
  return <Component {...props}>{props?.children}</Component>
};

export default withNavBars;
